import { useEffect, useState } from "react";
import { Button, Image } from "react-bootstrap";
import { AddModal } from "./Modals";
import { addHomePhotos, deleteHomePhoto, fetchHomePhotos } from "../contexts/fetchGalleryData";

const dataStructure = [
    {
        title: "Add Images",
        type: "files",
        field: "imgs",
        init: [],
    },
]



const DBHomeFigures = () => {

    const [isShowA, setShowA] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchHomePhotos(setData);
        return () => {
            setShowA(false);
            setData([]);
        };
    }, []);

    const handleAddSubmit = async (e, data) => {
        e.preventDefault();
        try {

            if (!data.imgs || data.imgs.length === 0) {
                alert("Please select at least one image.");
                return;
            }

            if (data.imgs.length > 9) {
                alert("Maximum only 9 images");
                return;
            }

            for (const img of data.imgs) {
                if (!img) continue;
                if (img.size > 2 * 1024 * 1024) {
                    alert(`File "${img.name}" exceeds 2MB.`);
                    return;
                }
            }
            await addHomePhotos({ ...data });
            alert("Upload successful!");
            await fetchHomePhotos(setData);
            setShowA(false);
        } catch (error) {
            alert("Error uploading photo. Please try again.");
        }
    };


    const deletePhoto = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this photo?");
        if (!confirmDelete) return;

        try {
            await deleteHomePhoto(id);
            alert("This photo deleted successfully.");
            await fetchHomePhotos(setData);
        } catch (error) {
            alert("Failed to delete image.");
            console.error(error);
        }
    }

    return (
        <div>
            <div className="text-end">
                <Button variant="primary" onClick={() => setShowA(true)}>Add</Button>
            </div>
                
            {data.map((d) => (
                <div key={d.id} className="align-items-center mb-4">
                    {/* <ColImageList imgs={d.urls} /> */}
                    <Image src={d.url} alt='' style={{maxHeight: '300px', maxWidth: '80%'}} />
                    <br />
                    <Button variant="danger" onClick={() => deletePhoto(d.id)}>Delete</Button>
                </div>
            ))}
            <AddModal isShowM={isShowA} setShowM={setShowA} structure={dataStructure} onSubmit={handleAddSubmit} />            
        </div>
    )
}

export default DBHomeFigures;